import { message } from "antd";
import config from "utils/globals";
import AuthService from "utils/authService";
import axios from "axios";
import Cookies from "js-cookie";

export const handleConfigAreaTooltip = (type, date, areaValue, lineValue) => {
  switch (type) {
    case "pma":
      return `<div class =" divide-y divide-solid w-30 ">
        <div class ="text-center caption-12px-regular pt-2">تاریخ ${date ? date : 0
        } </div>
        <div class =" text-center caption-12px-demibold py-1 text-primary-2 ">بازده سبد: ٪${areaValue || "-"
        } </div>
        </div>
        <div class =" text-center caption-12px-demibold pb-2 text-blue-0 ">بازده شاخص: ٪${lineValue || "-"
        } </div>`;

    default:
      return `<div class =" divide-y divide-solid w-30 ">
        <div class ="text-center caption-12px-regular pt-2">تاریخ ${date ? date : 0
        } </div>
        <div class =" text-center caption-12px-demibold py-1 text-primary-2 ">${config.numberSeparator(areaValue) || "-"
        } ریال</div>
        </div>`;
  }
};

const uploadReceipt = async (url, options) => {
  const { onSuccess, file, onError } = options;
  const { REACT_APP_BACKEND_SERVER } = process.env;
  const user = await AuthService.getUser();

  const formData = new FormData();
  formData.append("file", file);

  return await axios
    .post(`${REACT_APP_BACKEND_SERVER}/${url}/`, formData, {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    })
    .then((response) => {
      return onSuccess(response);
    })
    .catch((error) => {
      return onError(error);
    });
};

export const uploadTransformer = ({ url, isMaximSize = false, size = 5 }) => {
  const uploadProps = {
    name: "file",
    multiple: false,
    customRequest: (file) => uploadReceipt(url, file),

    beforeUpload: (file) => {
      const format = ["image/png", "image/jpeg", "application/pdf"].includes(
        file.type
      );

      const isLt5M = file.size / 1024 / 1024 <= size;

      if (!format) {
        message.error(`فرمت فایل ${file.name} مجاز نمی باشد.`);
      }

      if (isMaximSize && !isLt5M) {
        message.error(`فایل مورد نظر نباید کمتر از ${size} مگابایت باشد.`);
      }
    },
    onChange(info) {
      if (info.file.status === "done") {
        message.success(`${info.file.name} با موفقیت آپلود شد`);
        return (info.file.name = "فیش بانکی");
      } else if (info.file.status === "error") {
        message.error(`آپلود${info.file.name} ناموفق بود`);
        return (info.file.name = "فیش بانکی");
      }
    },
  };
  return uploadProps;
};

export const handleAlertInFirstView = (response, oldVersion, prevMenu) => {
  if (Cookies.get("update_alert") === "false" && prevMenu === "/callback") {
    response?.update_version > oldVersion
      ? Cookies.set("update_alert", "true")
      : Cookies.set("update_alert", "false");
  }

  if (!oldVersion) {
    Cookies.set("version", response?.update_version);
    Cookies.set("update_alert", "false");
  } else if (response?.update_version > oldVersion) {
    if (Cookies.get("update_alert") !== "false") {
      Cookies.set("update_alert", "true");
    }
  } else {
    Cookies.set("update_alert", "false");
  }
};

export const hexToRgb = (hex) => {
  const bigint = parseInt(hex.replace("#", ""), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `${r}, ${g}, ${b}`;
};
